import { expandAndEnableSection, collapseAndDisableSection } from "./collapse";

export function CustomCheckoutFieldListeners() {
  const verzendContainer = document.getElementById("order_review");

  if (!verzendContainer) {
    return;
  }

  observeDOM(verzendContainer, () => {
    shippingDialog();
    toggleMomentSelectors();
  });

  verzendContainer.addEventListener("click", () => {
    shippingDialog();
    toggleMomentSelectors();
  });

  shippingDialog();
  toggleMomentSelectors();
}

function toggleMomentSelectors() {
  const pickup = document.querySelector("[id*='local_pickup']");
  const sectionBezorg = document.getElementById("bezorgmoment_field");
  const sectionAfhaal = document.getElementById("afhaalmoment_field");

  if (!pickup) {
    collapseAndDisableSection(sectionAfhaal);
    expandAndEnableSection(sectionBezorg);
    return;
  }

  if (pickup.checked || pickup.type == "hidden") {
    collapseAndDisableSection(sectionBezorg);
    expandAndEnableSection(sectionAfhaal);
  } else {
    collapseAndDisableSection(sectionAfhaal);
    expandAndEnableSection(sectionBezorg);
  }
}

function shippingDialog() {
  const localPickup = document.querySelector("[id*='local_pickup']");
  if (!localPickup) {
    return;
  }

  const shippingDialog = document.getElementById("shipping_dialog");
  if (!shippingDialog) {
    return;
  }

  shippingDialog.classList.add("hidden");
  // if pickup is the only option
  if (localPickup.type === "hidden") {
    shippingDialog.classList.remove("hidden");
  }
}

var observeDOM = (function() {
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  return function(obj, callback) {
    if (!obj || obj.nodeType !== 1) return;

    if (MutationObserver) {
      // define a new observer
      var mutationObserver = new MutationObserver(callback);

      // have the observer observe foo for changes in children
      mutationObserver.observe(obj, { childList: true, subtree: true });
      return mutationObserver;
    }

    // browser support fallback
    else if (window.addEventListener) {
      obj.addEventListener("DOMNodeInserted", callback, false);
      obj.addEventListener("DOMNodeRemoved", callback, false);
    }
  };
})();
